import ExploreIdeasListCard from './ExploreIdeasListCard';
import { useExploreIdeasListArtifactUi } from '../hooks/useExploreIdeasListArtifactUi';

export interface ExploreIdeasListCardSectionProps {
  ideaIds: string[];
  artifactId?: string;
  stateKey: string;
  onRowClick: (ideaId: string, artifactId?: string, ideasPage?: number) => void;
}

export function ExploreIdeasListCardSection({
  ideaIds,
  artifactId,
  stateKey,
  onRowClick,
}: ExploreIdeasListCardSectionProps) {
  const {
    page,
    selectedIdeaId,
    isSelectionActive,
    hasUrlIdeasPage,
    onPageChange,
    rememberRowSelection,
    computePageForIdeaId,
  } = useExploreIdeasListArtifactUi(stateKey, artifactId);

  const handleRowClick = (ideaId: string) => {
    const targetPage = computePageForIdeaId(ideaId, ideaIds);
    rememberRowSelection(ideaId, targetPage);
    onRowClick(ideaId, artifactId, targetPage);
  };

  return (
    <ExploreIdeasListCard
      ideaIds={ideaIds}
      artifactId={artifactId}
      page={page}
      onPageChange={onPageChange}
      selectedIdeaId={selectedIdeaId}
      isSelectionActive={isSelectionActive}
      hasUrlIdeasPage={hasUrlIdeasPage}
      onRowClick={handleRowClick}
    />
  );
}

export default ExploreIdeasListCardSection;
